import type { ReactElement, ReactNode } from 'react';
import { css, styled } from 'styled-components';
import type { Button, IconButton, Link } from '../common';
import { ProcessStartWizardRowAction } from './rowComponents/ProcessStartWizardRowAction';
import { ProcessStartWizardRowBody } from './rowComponents/ProcessStartWizardRowBody';
import { ProcessStartWizardRowLabel } from './rowComponents/ProcessStartWizardRowLabel';

interface IProcessStartWizardRowProps {
    actionComponent?: ReactElement<typeof Button | typeof Link | typeof IconButton>;
    children: ReactNode[] | ReactNode;
    header?: boolean;
    icon?: string;
    label?: string;
    result?: boolean;
    wrapChildren?: boolean;
}

export function ProcessStartWizardRow(props: IProcessStartWizardRowProps) {
    const children = Array.isArray(props.children) ? (props.children as ReactNode[]) : [props.children];

    return (
        <StyledFormWizardRow
            $result={props.result}
            className="automation-formWizardRow"
        >
            <RowItemsContainer>
                {props.label && (
                    <ProcessStartWizardRowLabel
                        hasActionComponent={!!props.actionComponent}
                        header={props.header}
                        icon={props.icon}
                        label={props.label}
                        result={props.result}
                    />
                )}
                <ProcessStartWizardRowBody
                    hasAction={!!props.actionComponent}
                    result={props.result}
                    wrapChildren={props.wrapChildren}
                >
                    {children}
                </ProcessStartWizardRowBody>
                {props.actionComponent && <ProcessStartWizardRowAction actionComponent={props.actionComponent} />}
            </RowItemsContainer>
        </StyledFormWizardRow>
    );
}

const StyledFormWizardRow = styled.div<{ $result?: boolean }>`
    padding: 1.375rem 1.5rem;

    ${({ $result, theme }) =>
        $result &&
        css`
            border-bottom: 1px solid ${theme.colors.neutral100};
        `}

    & + & {
        border-top: 1px solid ${({ theme }) => theme.colors.neutral100};
        margin-top: -1px;
    }
`;

const RowItemsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    align-items: self-start;
    justify-content: space-between;
`;
